import { IconSitemap, IconEnvelopeAlt } from '@maia/icons';
import { ButtonLink, InfoCard, PageHeader, StaticNotification } from '@maia/ui';
import { createFileRoute, useParams } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/claims/new/_layout/$customer/link-send',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const params = useParams({
    from: '/_authenticated/claims/new/_layout/$customer/link-send',
  });

  return (
    <>
      <PageHeader
        title="Er is een slimme claim link verstuurt"
        description="Er gebeuren allemaal slimme dingen"
        className="area-page-header"
      />

      <div className="area-page-content content-grid">
        <StaticNotification
          variant="info"
          size="small"
          className="col-span-full"
        >
          <span className="font-medium">Belangrijk!</span> De claim moet nog wel
          afgerond worden door de klant
        </StaticNotification>

        <ul className="space-y-12 col-span-full">
          <li>
            <InfoCard
              icon={IconSitemap}
              title="Altijd de juiste claimflow"
              description="Het systeem weet nu welk claim systeem gebruikt moet worden. Zo weet je zeker dat de klant op de juiste plek terecht komt."
            />
          </li>
          <li>
            <InfoCard
              icon={IconEnvelopeAlt}
              title="Start claim proces email"
              description="De klant ontvangt een link en kan direct het juiste claim proces starten."
            />
          </li>
        </ul>

        <div className="col-span-full flex justify-end">
          <ButtonLink
            to="/customers/$guid"
            params={{ guid: params.customer }}
            intent="primary"
          >
            Terug naar klant
          </ButtonLink>
        </div>
      </div>

      <div className="area-page-sidebar invisible"></div>
    </>
  );
}
